// Company registration slice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

export interface IUserRegistrationInfo {
  name: string;
  email:string;
  profileImage?:string;
  id:string;
}

export interface IUserDbInfo{
  email:string;
  state: string;
}

const initialState: IUserRegistrationInfo = {
 name: "",
 email: "",
 id: ""
};


export const userRegistrationSlice = createSlice({
  name: "userRegistration",
  initialState,
  reducers: {
    registerUserInfo: (
      state,
      action: PayloadAction<IUserRegistrationInfo>
    ) => {
      return { ...state, ...action.payload };
    },
    updateUserInfo: (
      state,
      action: PayloadAction<IUserRegistrationInfo>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { registerUserInfo, updateUserInfo } = userRegistrationSlice.actions;
export const userRegistrationSelector = (state: RootState) => state.userRegistrationReducer;
export default userRegistrationSlice.reducer;
